// @flow

import { createContext } from 'react';

export type HeaderContextType = number;

export default createContext<HeaderContextType>(0);
